import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imageUrl, readingTime } from "@/lib/api";
import { ArticleMeta } from "@/components/site/Meta";
import { ArticleList } from "@/components/site/ArticleItem";
import { SECTIONS } from "@/lib/sections";
import { MostRead } from "@/components/site/MostRead";

const LeadStory = ({ a }) => (
  <article data-testid="lead-story-card" className="fade-up grid gap-8 lg:grid-cols-[1fr_1fr] items-start pt-12 pb-14 border-b border-[var(--ink)]">
    <div className={a.image_path ? "" : "lg:col-span-2 max-w-3xl"}>
      <p className="meta mb-5">Latest</p>
      <ArticleMeta article={a} idPrefix="lead-story" />
      <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight">
        <Link to={`/article/${a.slug}`} className="headline-link" data-testid="lead-story-link">{a.headline}</Link>
      </h1>
      {a.standfirst && <p className="mt-6 font-display italic text-xl sm:text-2xl text-[var(--ink-2)] leading-snug">{a.standfirst}</p>}
      <p className="mt-6 meta !normal-case !tracking-normal !font-normal">{readingTime(a.body)} min read</p>
    </div>
    {a.image_path && (
      <Link to={`/article/${a.slug}`} className="block overflow-hidden">
        <img src={imageUrl(a.image_path)} alt="" className="w-full aspect-[4/3] object-cover grayscale-[15%] hover:scale-[1.02] transition-transform duration-700" data-testid="lead-story-image" />
      </Link>
    )}
  </article>
);

export default function Home() {
  const [articles, setArticles] = useState(null);
  useEffect(() => { api.get("/articles", { params: { limit: 30 } }).then((r) => setArticles(r.data)); }, []);
  if (!articles) return <p className="py-24 meta" data-testid="home-loading">Loading</p>;
  const [lead, ...rest] = articles;

  return (
    <div data-testid="home-page">
      {lead ? <LeadStory a={lead} /> : <p className="py-24 italic text-[var(--ink-3)]">No articles yet.</p>}
      <div className="grid gap-14 lg:grid-cols-[2fr_1fr] pt-10">
        <section>
          <h2 className="meta !text-[var(--ink)] pb-3 border-b border-[var(--rule)]">Recent</h2>
          <ArticleList articles={rest} empty="More pieces are on the way." testId="recent-articles" />
          <MostRead className="mt-16" id="home-most-read" />
        </section>
        <aside className="lg:border-l lg:border-[var(--rule)] lg:pl-10">
          <h2 className="meta !text-[var(--ink)] pb-3 border-b border-[var(--rule)]">Sections</h2>
          {SECTIONS.map((s) => (
            <Link key={s.slug} to={`/section/${s.slug}`} className="group block py-5 border-b border-[var(--rule)]" data-testid={`home-section-${s.slug}`}>
              <span className="font-display text-xl font-semibold group-hover:text-[var(--accent)] transition-colors">{s.name}</span>
              <p className="mt-1 text-sm text-[var(--ink-2)] leading-relaxed">{s.blurb}</p>
            </Link>
          ))}
        </aside>
      </div>
    </div>
  );
}
